import UserActionTypes from './user-types';

export const setCurrentUser = (user) => ({
  type: UserActionTypes.SET_CURRENT_USER,
  payload: user,
});

export const setCurrentUserRol = (userRol) => ({
  type: UserActionTypes.SET_CURRENT_USER_ROL,
  payload: userRol,
});

export const setCurrentUserNivel = (userNivel) => ({
  type: UserActionTypes.SET_CURRENT_USER_NIVEL,
  payload: userNivel,
});

export const userLogout = () => ({
  type: UserActionTypes.USER_LOGOUT
});

export const cambiarEstatus = (nuevoEstatus) => ({
  type: UserActionTypes.CAMBIAR_ESTATUS,
  payload: nuevoEstatus
});

export const registrarTerminado = (exito) => ({
  type: UserActionTypes.REGISTRO_TERMINADO,
  payload: exito
});

export const implantarAspirante = (aspirante) => ({
  type: UserActionTypes.IMPLANTACION_ASPIRANTE,
  payload: aspirante
});

export const setEstadoDistritoAspirante = (estadoDistrito) => ({
  type: UserActionTypes.SET_ESTADO_DISTRITO_ASPIRANTE,
  payload: estadoDistrito
});

export const setFechaHoraActividad = (fechaHoraActividad) => ({
  type: UserActionTypes.SET_FECHA_HORA_ACTIVIDAD,
  payload: fechaHoraActividad
});